<div class="authorization-container">
  <div class="header-section">
    <button
      type="button"
      mat-icon-button
      class="close-button"
      aria-label="Close"
      (click)="close()"
      tabindex="-1"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="logo">
      <img src="/assets/images/transend-logo-title.png" alt="Transend Logo" />
    </div>
  </div>

  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (errorMessage) {
    <div class="error-container">
      <p class="error-message">{{ errorMessage }}</p>
    </div>
  } @else if (taaHtml) {
    <div class="taa-content" [appSanitizedHtml]="taaHtml"></div>
  }
</div>
